module.exports = __webpack_public_path__ + "static/media/POLYGON.1ee4a1ab.png";